// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-respondents-alert-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
}

.manage-respondents-alert {
  max-width: 39.6875rem;
  display: flex;
  align-items: center;
  padding: 0.625rem;
  margin: 10px auto;
  line-height: 1.3;
}
@media screen and (max-width: 665px) {
  .manage-respondents-alert {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/containers/dashboard-home/dashboard-home.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/dashboard/containers/dashboard-home/dashboard-home.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;ACDF;;ADIA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;ACDF;ADEE;EAPF;IAQI,uBAAA;ECCF;AACF","sourcesContent":["@use \"../../../../assets/styles/global/utils\" as u;\r\n\r\n.manage-respondents-alert-container {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 9999;\r\n}\r\n\r\n.manage-respondents-alert {\r\n  max-width: u.rem(635px);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: u.rem(10px);\r\n  margin: 10px auto;\r\n  line-height: 1.3;\r\n  @media screen and (max-width: 665px) {\r\n    align-items: flex-start;\r\n  }\r\n}\r\n",".manage-respondents-alert-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 9999;\n}\n\n.manage-respondents-alert {\n  max-width: 39.6875rem;\n  display: flex;\n  align-items: center;\n  padding: 0.625rem;\n  margin: 10px auto;\n  line-height: 1.3;\n}\n@media screen and (max-width: 665px) {\n  .manage-respondents-alert {\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
